import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";
import heroImg from "@/assets/towns/calhan.jpg";

const CONFIG: SpokePageConfig = {
  slug: "web-design-seo-calhan",
  metaTitle: "Calhan Web Design & SEO | Local Google Maps Help",
  metaDescription: "Web design and SEO for Calhan, CO businesses. Websites from $1,850, local SEO and Google Maps from $950/month. Based in Colorado Springs, month-to-month.",
  breadcrumbs: [{ label: "Home", to: "/" }, { label: "Colorado Springs Headquarters", to: "/colorado-springs-headquarters" }],
  currentLabel: "Calhan",
  eyebrow: "Calhan, CO · El Paso County",
  h1: (
    <>
      Web Design &amp; SEO in <span className="text-brand-gold">Calhan, Colorado</span>
    </>
  ),
  heroDescription: "Help Calhan customers find you first on Google, Google Maps and AI search.",
  intro: "We build websites and local SEO for businesses in Calhan and the eastern plains along Highway 24. Chris Heidlebaugh works from our Woodmen Rd office in Colorado Springs, within our 60-mile service area, with 27 years of experience helping local companies get found.",
  definition: { term: "Calhan local SEO", body: "Making your business show up when people in and around Calhan search Google, Google Maps and AI tools for what you offer." },
  whatWeDo: [
    { title: "Calhan website", body: "A fast site with pages for your services and the Calhan area." },
    { title: "Google Maps", body: "A complete profile with photos, services and steady reviews." },
    { title: "Nearby towns", body: "Pages for Peyton, Ellicott and Falcon too." },
    { title: "AI search", body: "Plain answers ChatGPT and Google can repeat." },
    { title: "Clear pricing", body: "Websites from $1,850. Marketing from $950/mo." },
    { title: "Free audit", body: "See what is holding your Calhan rankings back." },
  ],
  whyThisMarket: [
    { heading: "Local searches", body: "Fewer local businesses compete here, so a solid Google Maps profile can stand out fast." },
    { heading: "El Paso County", body: "We know El Paso County and serve it from Colorado Springs." },
    { heading: "No long contracts", body: "Monthly marketing is month-to-month." },
  ],
  relatedLinks: [
    { to: "/marketing-calhan", label: "Marketing in Calhan: social, ads, reviews & Maps" },
    { to: "/colorado-springs-headquarters", label: "Our 60-mile service area" },
    { to: "/colorado-springs-office-woodmen-rd", label: "Our Woodmen Rd office" },
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
  ],
  faqs: [
    { q: "Do you work with businesses in Calhan?", a: "Yes. Calhan is in our 60-mile service area around Colorado Springs. We can meet in person or by video." },
    { q: "How much does a website cost?", a: "Websites are $1,850, $2,750 or $5,950 one-time with one year of hosting and SSL. Monthly marketing is $950, $1,650 or $2,750 per month." },
    { q: "How fast can my website be ready?", a: "Most websites are ready in under 7 business days." },
  ],
  serviceName: "Web Design and SEO in Calhan, CO",
  serviceDescription: "Web design, local SEO and Google Maps help for Calhan, Colorado businesses.",
  heroImage: { src: heroImg, alt: "Calhan, Colorado main street and grain silos on the eastern plains", geo: { lat: 39.0356, lng: -104.2972, city: "Calhan, CO" } },
  areaServed: "Calhan, CO",
};

export const Route = createFileRoute("/web-design-seo-calhan")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
